var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pm-list-template" }, [
    _c(
      "div",
      { class: `headers ${_setup.breakpoints.mobile && "mobile"} test` },
      [
        _c(
          "div",
          { staticClass: "form box-bubble" },
          [
            _c(_setup.PMListForm, {
              attrs: { "edit-id": _setup.pmListId },
              on: {
                "on-success": _setup.onSuccessHandler,
                "on-cancel": _setup.onCancelHandler
              }
            })
          ],
          1
        ),
        !_setup.pmListId
          ? _c(
              "div",
              { staticClass: "index box-bubble" },
              [
                _c(_setup.PMListIndex, {
                  ref: "pmListIndexRef",
                  on: { "on-edit": _setup.onEditHandler }
                })
              ],
              1
            )
          : _vm._e()
      ]
    ),
    _c(
      "div",
      { staticClass: "pm-list-item" },
      [
        _setup.pmListId
          ? _c(_setup.PMListItemTemplate, {
              attrs: { "pm-list-id": _setup.pmListId }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }